// Firebase configuration
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

// Your web app's Firebase configuration
// Replace these values with your actual Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyBsEbYgauTOUnRy6ozS4mBgLfGJdbbMgzg",
  authDomain: "direct-delhi-wholesale.firebaseapp.com",
  databaseURL: "https://direct-delhi-wholesale.firebaseio.com",
  projectId: "direct-delhi-wholesale",
  storageBucket: "direct-delhi-wholesale.appspot.com",
  messagingSenderId: "984451048327",
  appId: "1:984451048327:web:730bede61b86607d2a6922"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Realtime Database and get a reference to the service
export const db = getDatabase(app);

export default app;